import React, {useEffect, useRef, useState} from "react";
import {Container} from "@adobe/aem-react-editable-components";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";
import {InfiosSendEmailMandatory} from "../Forms/SendEmailMandatory/SendEmailMandatory.style";
import axios from "axios";
import Input from "../FormComponents/Input/Input";
import {WidgetInstance} from "friendly-challenge";

const FormContainer = (props) => {

    const {ThankYouWatcher, LoadingWatcher, captchaConfig, pageLanguage} = props;
    const mandatoryList = {};
    const optionalList = {};
    const buttonList = {};
    let newColumn = false;
    const mandatoryOrder = [];
    const optionalOrder = [];
    const buttonOrder = [];
    const ref = useRef(null);
    const searchParams = new URLSearchParams(window.location.search);
    const widgetRef = useRef(null);

    useEffect(() => {
        if (widgetRef?.current) {

            const options = {

                doneCallback: solution => {
                    let form = ref.current;
                    let button = form.querySelector('button');
                    button.removeAttribute("disabled")
                    button.classList.remove("disabled");
                },
                language: pageLanguage !== "fr"? pageLanguage: {
                    text_init: "Chargement...",
                    text_ready: "Vérification Anti-Robot",
                    button_start: "Cliquez ici pour vérifier",
                    text_fetching: "Chargement du défi",
                    text_solving: "Nous vérifions que vous n'êtes pas un robot...",
                    text_completed: "Je ne suis pas un robot",
                    text_completed_sr: "Vérification automatique des spams terminée",
                    text_expired: "Vérification anti-robot expirée",
                    button_restart: "Redémarrer",
                    text_error: "Échec de la vérification",
                    button_retry: "Recommencer",
                    text_fetch_error: "Problème de connexion avec"},
                ...captchaConfig
            }
            const widget = new WidgetInstance(widgetRef.current, options);
        }
    }, [captchaConfig, pageLanguage]);

    useEffect(() => {
        if (searchParams.get('submit') && !!sessionStorage.getItem("firstName")) {
            if (!!ThankYouWatcher) ThankYouWatcher(true);
        }

    }, [ThankYouWatcher, searchParams]);

    useEffect(() => {
        let form = ref.current;
        if (form) {
            form.setAttribute("novalidate", "");
        }
    }, [])


    function handleSubmit(event) {
        (async () => {
            let form = ref.current;

            let allValid = true;

            let inputs = form.elements;

            for (const element of inputs) {
                let input = element;

                let isNotBlocked = true;

                if(input.checkBlockListValidity){
                    isNotBlocked = await input.checkBlockListValidity();
                }

                if (input.checkValidity() && isNotBlocked) {
                    input.classList.remove("error");
                } else {
                    allValid = false;
                    input.classList.add('error');
                }
            }

            if (!allValid) {
                return;
            }

            let button = form.querySelector('button');

            if (button) {
                button.classList.add('disabled');
            }

            if (!!LoadingWatcher) LoadingWatcher(true);

            let formData = {};

            for (const element of inputs) {
                if (element.name && !element.disabled && element.value.trim()) {
                    formData[element.name] = element.value;
                }
            }

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: '/bin/infios-marketo',
                headers: {
                    'Content-Type': 'application/json',
                    'Cookie': 'cq-authoring-mode=TOUCH'
                },
                data: JSON.stringify(formData)
            };

            axios.request(config)
                .then((response) => {
                    for (const element of inputs) {
                        if (element.name) {
                            sessionStorage.setItem(element.name, element.value);
                        }
                    }
                    sessionStorage.setItem("openCFO", "true");
                    window.location.href = '?submit=success&' + searchParams.toString();
                })
                .catch((error) => {
                    console.error(error);
                    if (!!LoadingWatcher) LoadingWatcher(false);
                })
                .finally(() => {
                    if (button) {
                        button.classList.remove('disabled');
                    }
                });
        })();
        event.preventDefault();
        return false;
    }

    for (let value of props.cqItemsOrder) {
        if (props.cqItems[value][':type'] === 'infios/components/form/button') {
            buttonList[value] = props.cqItems[value];
            buttonOrder.push(value);
            continue;
        }
        newColumn = props.cqItems[value][':type'] === 'infios/components/richtext' ? !newColumn : newColumn;
        const list = newColumn ? mandatoryList : optionalList;
        const order = newColumn ? mandatoryOrder : optionalOrder;
        list[value] = props.cqItems[value];
        order.push(value);
    }

    return (
        <InfiosSendEmailMandatory action="#" ref={ref} data-analytics="form__send-email"
                                   onSubmit={event => handleSubmit(event)}>
            <div className='mandatory-form'>
                <Container {...props} cqItems={mandatoryList} cqItemsOrder={mandatoryOrder}/>
            </div>
            <div className='optional-form'>
                <Container {...props} cqItems={optionalList} cqItemsOrder={optionalOrder}/>
            </div>
            <Input
                noIcon
                className={"nt"}
                value={""}
                name={"pronoum"}
                labelText={"Pronoum"}
            />
            <div className="form__captcha" ref={widgetRef}></div>
            <Container {...props} cqItems={buttonList} cqItemsOrder={buttonOrder}/>
        </InfiosSendEmailMandatory>
    )
}

const FormContainerErrors = props => {
    return (
        <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ?
            <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>This
                component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
            <FormContainer {...props} />
        </ErrorBoundary>
    )
}


export default FormContainerErrors;
